export const ASSIGN_DIAGNOSTIC_TEST = `
  mutation AssignDiagnosticTest($studentId: String!, $courseName: String!) {
    assignDiagnosticTest(studentId: $studentId, courseName: $courseName) {
        testUrl,
        status
    }
 }`;
